// extracted by mini-css-extract-plugin
module.exports = {"hero":"Home_hero__NQ1he","rainbow":"Home_rainbow___WQJF","social":"Home_social__ZjpDn"};